import { AlertColor, Box, CircularProgress } from "@mui/material";
import { forwardRef } from "react";
import { QuickAccessWorkspace } from "../../../model/UserModel";
import { MiniCard } from "./MiniCard";
import { ViewMore } from "./ViewMore";
import { MiniCardNothingToShow } from "./MiniCardNothingToShow";
import { MiniCardNoWorkspaces } from "./MiniCardNoWorkspaces";
import { MiniCardNoWorkspaceAdmin } from "./MiniCardNoWorkspaceAdmin";
import { IFavoriteModel } from "../../../model/ItemModel";
import { MiniCardAllFavorites } from "./MiniCardAllFavorites";
import { FavoriteType } from "../../../enums/FavoriteType";

export interface IMinicardCaroulsel {
  informationCardType: "quickAccess" | "organizations";
  setPopupMessage: (set: string | undefined) => void;
  setSeverity: (set: AlertColor) => void;
  nameOrg: string;
  quickAccessWorkspaces: QuickAccessWorkspace[];
  setQuickAccessWorkspaces: (set: QuickAccessWorkspace[]) => void;
  adminSystem: boolean;
  isOrgAdmin: boolean;
  favorites: IFavoriteModel[];
  setNeedGetFavorites: (set: boolean) => void;
  setLoadingFavorites: (set: boolean) => void;
  loadingFavorites: boolean;
}

export const MiniCardCarousel = forwardRef<HTMLDivElement, IMinicardCaroulsel>((props, ref) => {

  const renderFavorites = () => {
    if (props.favorites?.length === 0) return <MiniCardNothingToShow />;
    return props.favorites?.map((favorite) => (
      <Box key={favorite.id} sx={{ flex: "0 0 auto", marginRight: "10px" }}>
        <MiniCard
          id={favorite.id}
          itemId={favorite.itemId}
          type={favorite.type}
          favoriteName={favorite.favoriteName}
          extension={favorite.extension}
          setLoadingFavorites={props.setLoadingFavorites}
          informationCardType={props.informationCardType}
          setPopupMessage={props.setPopupMessage}
          setSeverity={props.setSeverity}
          nameOrg={props.nameOrg}
          setQuickAccessWorkspaces={props.setQuickAccessWorkspaces}
          quickWorkspaces={[]}
          setNeedGetFavorites={props.setNeedGetFavorites}
          workspaceId={favorite.workspaceId!}
        />
      </Box>
    ));
  };

  const renderQuickAccess = () => {
    const { quickAccessWorkspaces, isOrgAdmin, adminSystem } = props;

    if (quickAccessWorkspaces?.length === 0 && props.favorites.length > 0) {
      return <MiniCardAllFavorites />;
    }

    if (quickAccessWorkspaces?.length === 0 && props.favorites.length === 0) {
      return isOrgAdmin || adminSystem ? <MiniCardNoWorkspaceAdmin /> : <MiniCardNoWorkspaces />;
    }

    return (
      <>
        {quickAccessWorkspaces?.map((workspace, index) => (
          <Box key={workspace.id || index} sx={{ flex: "0 0 auto", marginRight: "10px" }}>
            <MiniCard
              id={workspace.id}
              itemId={workspace.id}
              type={FavoriteType.Workspace}
              favoriteName={workspace.name}
              extension={undefined}
              setLoadingFavorites={props.setLoadingFavorites}
              informationCardType={props.informationCardType}
              setPopupMessage={props.setPopupMessage}
              setSeverity={props.setSeverity}
              nameOrg={props.nameOrg}
              setQuickAccessWorkspaces={props.setQuickAccessWorkspaces}
              quickWorkspaces={quickAccessWorkspaces}
              setNeedGetFavorites={props.setNeedGetFavorites}
              workspaceId=""
            />
          </Box>
        ))}
        {quickAccessWorkspaces?.length > 1 && (
          <ViewMore redirectUrl={`/${props.nameOrg}/wsallowed`} />
        )}
      </>
    );
  };

  return (
    <Box
      ref={ref}
      sx={{
        width: "100%",
        display: "flex",
        overflowX: "auto",
        '&::-webkit-scrollbar': { display: "none" },
        scrollbarWidth: "none",
      }}
    >
      {props.loadingFavorites ? <CircularProgress variant="indeterminate" /> : (
        props.informationCardType === "quickAccess" ? renderFavorites() : renderQuickAccess()
      )}
    </Box>
  );
});
